<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">{{'Invoices' | translate}}</h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative" routerLink="/">{{'Dashboard' | translate}}</li>
        <li class="breadcrumb-item position-relative">{{'All_Invoices_List' | translate}}</li>
    </ol>
</div>

<mat-card class="daxa-card users-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <app-search-input-with-debouncing 
                (searchEvent)="onSearch($event)" 
                placeholder="Search">
            </app-search-input-with-debouncing>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div class="users-table">
            <div class="table-responsive">

                <table mat-table [dataSource]="dataSource" matSort>

                    <!-- Id -->
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Id' | translate}}</th>
                        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
                    </ng-container>

                    <!-- User -->
                    <ng-container matColumnDef="user">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'User' | translate}}</th>
                        <td mat-cell *matCellDef="let row" class="text-black">
                            <span class="d-block fw-medium">
                                {{ row.user }}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Price -->
                    <ng-container matColumnDef="price">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Price' | translate}}</th>
                        <td mat-cell *matCellDef="let row">{{ row.price | currency:'DKK'}}</td>
                    </ng-container>

                    <!-- IssueDate -->
                    <ng-container matColumnDef="issueDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'IssueDate' | translate}}</th>
                        <td mat-cell *matCellDef="let row">{{ row.issueDate | date:'shortDate' }}</td>
                    </ng-container>

                    <!-- DueDate -->
                    <ng-container matColumnDef="dueDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'DueDate' | translate}}</th>
                        <td mat-cell *matCellDef="let row">{{ row.dueDate | date:'shortDate' }}</td>
                    </ng-container>

                    <!-- Status -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Status' | translate}}</th>
                        <td mat-cell *matCellDef="let row">
                            <span class="status-chip"
                                [ngClass]="{
                                    'sent': row.status === 'Sent',
                                    'failed': row.status === 'Failed'
                                }">
                                {{ row.status}}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Action -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>{{'Action' | translate}}</th>
                        <td mat-cell *matCellDef="let row">
                            <button mat-button class="daxa" matTooltip="{{'View invoice' | translate}}" (click)="onView(row)">
                                <i class="material-symbols-outlined">visibility</i>
                            </button>
                        </td>
                    </ng-container>

                    <!-- Header / Rows -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

                    <!-- Empty / Loading Row -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                        <ng-container *ngIf="isLoading; else noDataTpl">
                            <app-buffer-progress-bar></app-buffer-progress-bar>
                        </ng-container>
                        <ng-template #noDataTpl> No invoices found </ng-template>
                        </td>
                    </tr>
                </table>
            </div>
        <mat-paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[10,20,50]"
            showFirstLastButtons>
        </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>